import type { TUser } from '@entities/user/lib/types';
import { BaseAvatar, BaseButton, BaseNavHeader, BaseThemeToggle } from '@evrone-erp/uikit';
import { Typography } from '@mui/material';
import { LangSwitcher } from '@shared/ui/lang-switcher/LangSwitcher';
import { useTranslation } from 'next-i18next';
import React, { useState } from 'react';
import Cookies from 'js-cookie';

import { useLogout } from '@features';
import { absolutePathImageLoader, ROUTES, useOtpEnabled } from '@shared';
import { useRouter } from 'next/router';
import { EUserRoles } from '@entities/user/lib/const';
import { useDeimpersonate } from '@entities/user';

const IMPERSONATED_COOKIE_KEY = 'impersonated';
const logoProps = { href: ROUTES.root };
const avatarSx = { marginLeft: '10px' };
const avatarSize = 24;

export const AppHeader = ({ user }: { user?: TUser }) => {
  const otpEnabled = useOtpEnabled();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const router = useRouter();
  const { mutate } = useLogout();
  const isAdmin = user?.role === EUserRoles.superadmin;
  const { mutate: deimpersonate } = useDeimpersonate();
  const impersonated = Cookies.get(IMPERSONATED_COOKIE_KEY) === 'true';

  return (
    <BaseNavHeader
      position="sticky"
      open={open}
      logoProps={logoProps}
      accountButton={
        user ? (
          <BaseButton sx={{ marginLeft: 'auto' }} variant="text" onClick={() => setOpen((state) => !state)}>
            {user.name || user.email}
            <BaseAvatar
              placeholder=""
              sx={avatarSx}
              value={user.avatar?.thumb || user.avatar?.normal}
              size={avatarSize}
              imageLoader={absolutePathImageLoader}
            />
          </BaseButton>
        ) : (
          <div>
            <BaseThemeToggle sx={{ margin: '0 15px 0 auto' }} />
            <LangSwitcher />
          </div>
        )
      }
    >
      {user && (
        <>
          <BaseThemeToggle sx={{ margin: { tab: 'auto 0 auto', mob: '0 auto' } }} />
          <LangSwitcher />
        </>
      )}
      <BaseButton variant="text" onClick={() => mutate()}>
        {t('navigation.logout')}
      </BaseButton>
      {user && !user.shouldSetPassword && (!otpEnabled || user.otpVerify) && (
        <>
          {impersonated && (
            <BaseButton variant="text" onClick={() => deimpersonate()}>
              <Typography>{t('navigation.signBack')}</Typography>
            </BaseButton>
          )}
          <BaseButton variant="text" onClick={() => router.push(ROUTES.account)}>
            <Typography>{t('navigation.account')}</Typography>
          </BaseButton>
          {isAdmin && (
            <>
              <BaseButton variant="text" onClick={() => router.push(ROUTES.admin.users)}>
                <Typography>{t('navigation.users')}</Typography>
              </BaseButton>
              <BaseButton variant="text" onClick={() => router.push(ROUTES.admin.serviceProviders)}>
                <Typography>{t('navigation.serviceProviders')}</Typography>
              </BaseButton>
            </>
          )}
        </>
      )}
    </BaseNavHeader>
  );
};
